import {
  gettingCasingOD,
  setCasingDriftID,
  setCasingID,
  setCasingOD,
  setCasingWeightList,
  setCasingWeight,
  setLinerID,
  setLinerOD,
  setLinerTop,
  setLinerWeight,
  setTubingType,
  setTubingID,
  setTubingOD,
  setTubingTypeUpset,
  setTubingWeight,
  setLinerODList,
  setLinerWeightList,
  setWellTrajectoryList,
  setTubingODList,
  setTubingTypeUpsetList,
  clearCasingOD,
  clearCasingWeight,
  clearLiner,
  clearTubing,
  setTubingTypeList,
  setTubingWeightList,
  setWellTrajectory,
  setHiddenGasAutoEff,
  setUnit,
  setCatalogType,
  setChargePumpShowAll,
  setHiddenGasNatrAutoEff,
  setHiddenPumpShowAll,
  setHiddenSep1Eff,
  setHiddenSep2Eff,
  setHiddenSep3Eff,
  setHiddenSep4Eff,
  setHiddenMotorAuto,
  setHiddenMotorShowAll,
  setHiddenMotorSeries,
  setHiddenProtector1,
  setHiddenProtector2,
  setHiddenHousingType,
  setHiddenShaftType,
  setHiddenMotorId,
  setHiddenMotorShrdRequired,
  setHiddenCableSurfaceCabl,
  setHiddenCableEstCabLng,
  setHiddenCableDriftId,
  setHiddenCablePumpLockPlate,
  setHiddenCableSealLockPlate,
  setHiddenCableMotorLockPlate,
  setHiddenMotorShrdWt,
  setHiddenMotorSharedOD,
  setHiddenMotorSensor,
  setHiddenSurfaceSupplyVoltage,
  setHiddenSurfaceCstPrHr,
  setHiddenSurfacePowerFactor,
  setHiddenSurfaceEfficiency,
  setHiddenSurfaceVSD,
  setHiddenSurfaceSwitchBoard,
  setHiddenSurfaceControlType
} from "../../../store/calculation/calculation-input/TubingSlice";
import { setMotorLoadInput } from "../../../store/calculation/calculation-output/motorSlice";
import { setSurfaceCalculationComplete } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../store/hooks/StoreHooks";

const useTubingFacade = () => {
  const dispatch = useAppDispatch();
  const { tab1Input } = useAppSelector((state) => state?.tubing);

  const updateCasingWeightList = (payload: any) => {
    return dispatch(setCasingWeightList(payload));
  };

  const updateLinerODList = (payload: any) => {
    return dispatch(setLinerODList(payload));
  };

  const updateLinerWeightList = (payload: any) => {
    return dispatch(setLinerWeightList(payload));
  };

  const updateTubingODList = (payload: any) => {
    return dispatch(setTubingODList(payload));
  };

  const updateTubingTypeUpsetList = () => {
    const records = tab1Input?.tubingTypeUpsetList;
    if (!records) return [];
    const arrayValue = Object.keys(records).map((key) => ({
      value: records[key],
      label: key,
    }));
    return dispatch(setTubingTypeUpsetList(arrayValue));
  };

  const updateTubingTypeList = () => {
    const records = tab1Input?.tubingTypeList;
    if (!records) return [];
    const arrayValue = Object.keys(records).map((key) => ({
      value: records[key],
      label: key,
    }));
    return dispatch(setTubingTypeList(arrayValue));
  };

  const updateTubingWeightList = (payload: any) => {
    return dispatch(setTubingWeightList(payload));
  };

  const updateWellTrajectoryList = () => {
    const records = tab1Input?.wellTrajectoryList;
    if (!records) return [];
    const arrayValue = Object.keys(records).map((key) => ({
      value: records[key],
      label: key,
    }));
    return dispatch(setWellTrajectoryList(arrayValue));
  };

  const clearCasing = () => {
    return dispatch(clearCasingOD());
  };

  const linerODClear = () => {
    return dispatch(clearLiner());
  };

  const tubginODClear = () => {
    return dispatch(clearTubing());
  };
  const casingWeightClear = () => {
    return dispatch(clearCasingWeight());
  };

  const updateCasingOD = (payload: string) => {
    return dispatch(setCasingOD(payload));
  };
  const updateCasingWeight = (payload: string) => {
    return dispatch(setCasingWeight(payload));
  };
  const updateCasingID = (payload: string) => {
    return dispatch(setCasingID(payload));
  };
  const updateCasingDriftID = (payload: string) => {
    return dispatch(setCasingDriftID(payload));
  };
  const updateLinerOD = (payload: string) => {
    return dispatch(setLinerOD(payload));
  };
  const updateLinerWeight = (payload: string) => {
    return dispatch(setLinerWeight(payload));
  };
  const updateLinerID = (payload: string | number) => {
    return dispatch(setLinerID(payload));
  };
  const updateLinerTop = (payload: string) => {
    return dispatch(setLinerTop(payload));
  };
  const updateTubingOD = (payload: string) => {
    return dispatch(setTubingOD(payload));
  };
  const updateTubingID = (payload: string) => {
    return dispatch(setTubingID(payload));
  };
  const updateTubingType = (payload: string) => {
    return dispatch(setTubingTypeUpset(payload));
  };
  const updateTubingWeight = (payload: string) => {
    return dispatch(setTubingWeight(payload));
  };
  const updateTubing = (payload: string) => {
    return dispatch(setTubingType(payload));
  };

  const loadCasingOD = () => {
    return dispatch(gettingCasingOD());
  };

  const updateWellTrajectory = (payload: string) => {
    return dispatch(setWellTrajectory(payload));
  };

  const updateHiddenGasNatrAutoEff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenGasNatrAutoEff(payload));
  };

  const UpdatehdnMotrAutoHP = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenMotorAuto(payload));
  };

  const UpdatehdnMotrShowAll = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenMotorShowAll(payload));
  };

  const UpdatehdnMotorSeries = (payload: string) => {
    dispatch(setHiddenMotorSeries(payload));
  };

  const UpdatehiddenMotorSensor = (payload: string) => {
    dispatch(setHiddenMotorSensor(payload));
  };

  const updateHiddenGasAutoEff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenGasAutoEff(payload));
  };

  const updateUnit = (payload: string) => {
    return dispatch(setUnit(payload));
  };

  const updateCatalogType = (payload: number) => {
    return dispatch(setCatalogType(payload));
  };

  const updateChargePumpShowAll = (payload: boolean) => {
    return dispatch(setChargePumpShowAll(payload));
  };

  const updatehdnPmpShowAll = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenPumpShowAll(payload));
  };

  const updateHdnPumpShaftType = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenShaftType(payload));
  };

  const updateHiddenSep1Eff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenSep1Eff(payload));
  };

  const updateHiddenSep2Eff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenSep2Eff(payload));
  };

  const updateHiddenSep3Eff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenSep3Eff(payload));
  };

  const updateHiddenSep4Eff = (payload: string) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenSep4Eff(payload));
  };

  const updatehdnPumpHousinType = (payload: any) => {
    return dispatch(setHiddenHousingType(payload));
  };

  const updatehiddenProtector1 = (payload: string) => {
    return dispatch(setHiddenProtector1(payload));
  };

  const updateHiddenProtector2 = (payload: string) => {
    return dispatch(setHiddenProtector2(payload));
  };

  const updateHiddenMotorId = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setMotorLoadInput(null));
    dispatch(setHiddenMotorId(payload));
  };

  const updateShroudODRequired = (payload: any) => {
    return dispatch(setHiddenMotorShrdRequired(payload));
  };

  const updateHiddenSurfaceCabl = (payload: any) => {
    return dispatch(setHiddenCableSurfaceCabl(payload));
  };

  const updateHiddenCableEstCabLng = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenCableEstCabLng(payload));
  };

  const updateShroudOD = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    return dispatch(setHiddenMotorSharedOD(payload));
  };
  const updateShroudWeight = (payload: any) => {
    return dispatch(setHiddenMotorShrdWt(payload));
  };

  const updateHiddenCableDriftId = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenCableDriftId(payload));
  };

  const updateHiddenCablePumpLockPlate = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenCablePumpLockPlate(payload));
  };

  const updateHiddenCableSealLockPlate = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenCableSealLockPlate(payload));
  };

  const updateHiddenCableMotorLockPlate = (payload: any) => {
    dispatch(setSurfaceCalculationComplete(false));
    dispatch(setHiddenCableMotorLockPlate(payload));
  };

  const updateHiddenSurfaceSupplyVoltage = (payload: any) => {
    return dispatch(setHiddenSurfaceSupplyVoltage(payload));
  };

  const updateHiddenSurfaceCostPerHour = (payload: any) => {
    return dispatch(setHiddenSurfaceCstPrHr(payload));
  };

  const updateHiddenSurfacePowerFactor = (payload: any) => {
    return dispatch(setHiddenSurfacePowerFactor(payload));
  };

  const updateHiddenSurfaceEfficiency = (payload: any) => {
    return dispatch(setHiddenSurfaceEfficiency(payload));
  };

  const updateHiddenSurfVSD = (payload: any) => {
    return dispatch(setHiddenSurfaceVSD(payload));
  };

  const updateSurfaceControllerType = (payload: any) => {
    return dispatch(setHiddenSurfaceControlType(payload));
  };

  const updateHiddenSwitchBoard = (payload: string) => {
    return dispatch(setHiddenSurfaceSwitchBoard(payload));
  };

  return {
    updateCasingOD,
    updateCasingWeight,
    updateCasingID,
    updateCasingDriftID,
    updateLinerOD,
    updateLinerWeight,
    updateLinerID,
    updateLinerTop,
    updateTubingOD,
    updateTubingID,
    updateTubingType,
    updateTubingWeight,
    updateTubing,
    updateCasingWeightList,
    loadCasingOD,
    updateLinerODList,
    updateLinerWeightList,
    updateWellTrajectoryList,
    updateTubingODList,
    updateTubingTypeUpsetList,
    updateTubingTypeList,
    clearCasing,
    casingWeightClear,
    linerODClear,
    tubginODClear,
    updateTubingWeightList,
    updateWellTrajectory,
    updateHiddenGasNatrAutoEff,
    updateHiddenGasAutoEff,
    updateUnit,
    updateCatalogType,
    updateChargePumpShowAll,
    updateHdnPumpShaftType,
    updatehdnPmpShowAll,
    updateHiddenSep1Eff,
    updateHiddenSep2Eff,
    updateHiddenSep3Eff,
    updateHiddenSep4Eff,
    UpdatehdnMotrAutoHP,
    UpdatehdnMotrShowAll,
    UpdatehdnMotorSeries,
    updatehiddenProtector1,
    updateHiddenProtector2,
    updatehdnPumpHousinType,
    updateHiddenMotorId,
    updateShroudODRequired,
    updateHiddenSurfaceCabl,
    updateHiddenCableEstCabLng,
    updateHiddenCableDriftId,
    updateHiddenCablePumpLockPlate,
    updateHiddenCableSealLockPlate,
    updateHiddenCableMotorLockPlate,
    updateShroudOD,
    updateShroudWeight,
    UpdatehiddenMotorSensor,
    updateHiddenSurfaceSupplyVoltage,
    updateHiddenSurfaceCostPerHour,
    updateHiddenSurfacePowerFactor,
    updateHiddenSurfaceEfficiency,
    updateHiddenSurfVSD,
    updateHiddenSwitchBoard,
    updateSurfaceControllerType
  };
};

export default useTubingFacade;
